import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { QuotationDetailModel } from 'src/app/models/preliminaries/quotation-detail.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { BreakdownService } from 'src/app/services/preliminaries/breakdown.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-distribute-total-value-breakdown',
  templateUrl: './distribute-total-value-breakdown.component.html',
  styleUrls: ['./distribute-total-value-breakdown.component.scss'],
  standalone: false
})
export class DistributeTotalValueBreakdownComponent implements OnInit {

  formValueDistribute: FormGroup = new FormGroup({});
  quotationSolutionContract: QuotationDetailModel = new QuotationDetailModel();
  suscription: Subscription;

  constructor(private breakdownService: BreakdownService,
    private formBuilder: FormBuilder,
    private confirmDialogService: ConfirmDialogService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) { }

  ngOnInit() {
    this.validateFormDistribute();

    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.quotationSolutionContract = inputs.quotationSolutionModel;
    });
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  async totalValueDistribute() {
    const totalValueDistribute = this.formValueDistribute.get("totalValueDistribute")?.value ?? 0;
    if (totalValueDistribute == 0) {
      this.toastHandlerService.showToast('warning', 'El valor a distribuir  no es válido', '');
      return;
    }

    const response = await firstValueFrom(this.breakdownService.totalValueDistribute(this.quotationSolutionContract.quotationDetailId, totalValueDistribute));
    if (response) {
      const output$ = this.config.data?.output$;
      output$?.next({ type: 'updateList', payload: true });
      this.toastHandlerService.showToast('success', 'El vr.total se distribuyo exitosamente.', '');
    }
    this.validateFormDistribute();
    if (this.ref) this.ref.close();
  }

  validateFormDistribute() {
    this.formValueDistribute = this.formBuilder.group({
      totalValueDistribute: [0, []]
    })
  }

}
